import React, { useEffect, useState } from "react";

const Checkbox = ({ medium, status, selected, setSelected }) => {
  const [checked, setChecked] = useState(false);

  const checkBoxChangeHandler = (e) => {
    if (e.target.checked) {
      setSelected([...selected, medium.id]);
    } else {
      setSelected(selected.filter((id) => id !== medium.id));
    }
    setChecked(e.target.checked);
  };
  useEffect(() => {
    setChecked(status);
  }, [status]);
  useEffect(() => {
    setSelected([]);
    setChecked(false);
  }, [medium]);
  return (
    <>
      <input
        onChange={checkBoxChangeHandler}
        checked={checked}
        value={medium.id}
        type="checkbox"
        id={`checkbox${medium.id}`}
        name={`checkbox${medium.id}`}
      />
      <label htmlFor={`checkbox${medium.id}`}></label>
    </>
  );
};

export default Checkbox;
